import classNames from "classnames";
import Popover from "components/DesignSystem/Popover/Popover";
import { useActionItems } from "hooks/useActionItems";
import { ReactNode, useRef, useState } from "react";
import { Timeout } from "react-number-format/types/types";
import { useLocation } from "react-router-dom";
import WarningCircle from "static/images/WarningCircle.svg";
import { openLink } from "utils/openLink";

const PopoverContent = ({
  title,
  body,
  btnText,
  onClick,
}: {
  title: string;
  body: ReactNode;
  btnText?: string;
  onClick?: () => void;
}) => {
  return (
    <div className="t-flex t-flex-col t-gap-2 t-text-white">
      <Popover.Header>{title}</Popover.Header>
      <div
        className={classNames("t-text-body-sm", {
          "t-mb-2": Boolean(btnText),
        })}
      >
        {body}
      </div>
      {btnText && (
        <button
          className="all:unset t-underline t-text-subtext-sm"
          onClick={onClick}
        >
          {btnText}
        </button>
      )}
    </div>
  );
};

const RequiredActionsContent = () => {
  const { search } = useLocation();
  const { isBankReconnectRequired } = useActionItems();

  const openDataSources = () => openLink(`/books/data-sources${search}`);

  if (isBankReconnectRequired) {
    return (
      <PopoverContent
        title=""
        body="Account disconnected. Please reconnect to resume syncing transactions."
        btnText="Reconnect"
        onClick={openDataSources}
      />
    );
  }

  return null;
};

export const ActionRequiredPopOver = () => {
  const [pop, setPop] = useState(false);
  const closeRef = useRef<Timeout | null>(null);
  const { action_items_count: actionItemsResponseLength } = useActionItems();

  const onClose = () => {
    if (closeRef.current) {
      clearTimeout(closeRef.current);
    }

    closeRef.current = setTimeout(() => {
      setPop(false);
    }, 200);
  };

  const onOpen = () => {
    closeRef.current && clearTimeout(closeRef.current);
    setPop(true);
  };

  if (actionItemsResponseLength === 0) {
    return null;
  }

  return (
    <Popover.Root open={pop}>
      <Popover.Trigger
        asChild
        onMouseEnter={onOpen}
        onMouseLeave={onClose}
        onClick={(e) => e.preventDefault()}
      >
        <button className="all:unset">
          <img
            src={WarningCircle}
            alt="WarningCircle"
            className="t-w-5 t-h-5"
          />
        </button>
      </Popover.Trigger>
      <Popover.Portal>
        <Popover.Content
          asChild
          className="t-w-[310px]"
          onMouseEnter={onOpen}
          onMouseLeave={onClose}
        >
          <RequiredActionsContent />
        </Popover.Content>
      </Popover.Portal>
    </Popover.Root>
  );
};
